"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamModel = void 0;
/* eslint-disable max-len */
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
const PositionModel_1 = __importDefault(require("./PositionModel"));
class TeamModel extends Model_1.default {
    constructor(o) {
        super(o);
        super.init(o);
        this.positions = (this.positions || []).map(v => new PositionModel_1.default(v));
    }
    get __typename() {
        return 'Team';
    }
    set __typename(v) {
    }
}
exports.TeamModel = TeamModel;
TeamModel.ALL_FIELDS = `id, title, positions { id, title }`;
exports.default = TeamModel;
ModelRegistry_1.default[DataType_1.default.TEAM] = TeamModel;
